import { ES_UI } from "@/i18n/es.ui";
import { ES_CONTENT } from "@/i18n/es.content";
import { ES_PORTAL } from "@/i18n/es.portal";

export const ES = { ...ES_UI, ...ES_CONTENT, ...ES_PORTAL };
